import colors from "core/resources/theme/colors";
import { BsPersonCheckFill, BsFillPersonXFill } from "react-icons/bs";
import Card2Horizontal from "components/Cards/Card2Horizontal";
import { SimpleGrid } from "@chakra-ui/react";
import { HiUserGroup } from "react-icons/hi";
import { UnidadesDashboard } from "features/unidades/typings/unidade";
import { MdHomeWork } from "react-icons/md";
interface DashboardUnidadesProps {
  data: UnidadesDashboard | undefined;
  loading?: boolean;
}

function DashboardUnidades({ data, loading }: DashboardUnidadesProps) {
  const moradores = data?.totalMoradores || 0;
  const adimplentes = data?.unidadesAdimplentes || 0;
  const inadimplentes = data?.unidadesInadimplentes || 0;
  const unidades = data?.totalUnidades || 0;
  return (
    <SimpleGrid columns={{ sm: 1, md: 2, lg: 4 }} gap="16px" mb="32px">
      <Card2Horizontal
        icon={<HiUserGroup fontSize="24px" color={colors.blue500} />}
        color={colors.blue}
        bg={colors.blue100}
        description="Pessoas"
        title={`${moradores}`}
        loading={loading}
      />

      <Card2Horizontal
        icon={<MdHomeWork fontSize="24px" color={colors.blue500} />}
        color={colors.blue}
        bg={colors.blue100}
        description="Unidades"
        title={`${unidades}`}
        loading={loading}
      />

      <Card2Horizontal
        icon={<BsPersonCheckFill fontSize="24px" color={colors.green} />}
        color={colors.green}
        bg={colors.green100}
        description="Adimplentes"
        title={`${adimplentes}`}
        loading={loading}
      />

      <Card2Horizontal
        icon={<BsFillPersonXFill fontSize="24px" color={colors.orange} />}
        color={colors.orange}
        bg={colors.orange10}
        description="Inadimplentes"
        title={`${inadimplentes}`}
        loading={loading}
      />
    </SimpleGrid>
  );
}

export default DashboardUnidades;
